import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import SponsorshipCard from '../../../DetailsTab/components/SponsorshipCard';
import PieChart from '@ui/components/PieChart';
import { useTranslation } from 'react-i18next';
const EventsStatusCard = ({ activeCount, inactiveCount }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    // Build data points and remove zero-value categories to avoid clutter
    const raw = [
        {
            label: t('common.linked') || 'Linked',
            value: activeCount,
            color: theme.palette.primary.main
        },
        {
            label: t('common.notLinked') || 'Not Linked',
            value: inactiveCount,
            color: theme.palette.grey[400]
        }
    ];
    const filtered = raw.filter((d) => d.value > 0);
    const labels = filtered.map((d) => d.label);
    const values = filtered.map((d) => d.value);
    const colors = filtered.map((d) => d.color);
    return (_jsx(SponsorshipCard, { heading: t('sponsorships.events'), variant: 'success', height: '200px', disableShadow: true, children: values.length > 0 ? (_jsx(PieChart, { data: {
                labels,
                values,
                colors
            }, borderWidth: 2, showLegend: true, height: 120 })) : (_jsx("div", { style: { height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx("span", { style: { color: theme.palette.text.secondary }, children: t('common.noData') }) })) }));
};
export default EventsStatusCard;
